// extracted by mini-css-extract-plugin
module.exports = {"selectInModal":"ProductSizes_selectInModal__bcB0r","filters":"ProductSizes_filters__3MSXR","isModal":"ProductSizes_isModal__2kaTN"};